import React from 'react';

const AlphabetPicker = ({ onClick = () => {}, style = {} }) => {
  const buttons = ['All', '#', ...'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('')];

  return (
    <div className="btn-group" role="group" aria-label="Alphabet Buttons" style={style}>
      {buttons.map((label) => (
        <button
          key={label}
          type="button"
          className="btn btn-outline-secondary"
          onClick={() => onClick(label)}
        >
          {label}
        </button>
      ))}
    </div>
  );
};

export default AlphabetPicker;
